import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=463378fd&scoped=true"
import script from "./DocumentViewer.vue?vue&type=script&lang=js"
export * from "./DocumentViewer.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewer.vue?vue&type=style&index=0&id=463378fd&prod&lang=scss&scoped=true"
import style1 from "./DocumentViewer.vue?vue&type=style&index=1&id=463378fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463378fd",
  null
  
)

export default component.exports